import type { FeatureCollection, Polygon } from "geojson";
import proj4 from "proj4";
import { EPSG_DEFS } from "../constants/epsg-defs";

export class CadSourceGeoReferenced {
    /** CAD geojson which is in Epsg 3857  */
    private _geoJson3857: FeatureCollection;

    /** The clipped polygon in the EPSG 3857 coordinate system */
    private _clippedPolygon3857: Polygon;

    /** The clipped polygon in the source coordinate system */
    private _clippedPolygonSource: Polygon;

    /** The source EPSG code of the CAD file */
    private _sourceEpsgCode: number;

    constructor(sourceEpsgCode: number) {
        this._sourceEpsgCode = sourceEpsgCode;
        const projection = EPSG_DEFS.find((def) => def.code === sourceEpsgCode);
        if (projection == null) {
            throw new Error(`Projection EPSG:${sourceEpsgCode} not found in EPSG_DEFS`);
        }
        proj4.defs(`EPSG:${sourceEpsgCode}`, projection.projection);
    }

    public setClip(clippedArea: Polygon) {
        this._clippedPolygon3857 = clippedArea;
        // Convert clippedArea from EPSG:4326 to source EPSG using proj4
        const from = "EPSG:4326";
        const to = `EPSG:${this._sourceEpsgCode}`;

        // Convert all coordinates in the polygon
        const convertedCoordinates = clippedArea.coordinates.map((ring) => ring.map((coord) => proj4(from, to, [coord[0], coord[1]])));

        this._clippedPolygonSource = {
            type: "Polygon",
            coordinates: convertedCoordinates,
        };
    }

    // Returns the clipped polygon in EPSG:3857
    public get clippedSourcePolygon3857(): Polygon {
        return this._clippedPolygon3857;
    }

    public get clippedPolygonSource(): Polygon {
        return this._clippedPolygonSource;
    }
}
